import { MutableRefObject, useEffect, useState } from "react";

/**
 * Hook for determining if an element is visible on screen
 * @param ref Reference to the element to monitor
 * @param rootMargin Amount of the element that must be visible to be considered true "10px"
 */
export function useOnScreen(
  ref: MutableRefObject<HTMLElement | undefined>,
  rootMargin: string = "0px"
) {
  // State and setter for storing whether element is visible
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const { current } = ref;
    if (!current) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Update our state when observer callback fires
        setIntersecting(entry.isIntersecting);
      },
      {
        rootMargin,
      }
    );
    if (current) {
      observer.observe(current);
    }
    return () => {
      observer.unobserve(current);
    };
  }, [ref, rootMargin]); // Empty array ensures that effect is only run on mount and unmount

  return isIntersecting;
}
